import React, { useEffect, useState } from "react";
import s from "./Movements.module.css";

//Servicio
import couponsService from "../../../../api/delivery/couponsService";

//assets
import { setSelectedCoupon } from "../../../../store/slices/couponsSlice";
import { dateFormats } from "../../../../helpers/convertDate";
import { Currency } from "../../../../helpers/currencyConvert";
import { useParams, useNavigate } from "react-router-dom";
import Pager from "../../../Shared/Pagination/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

//Material
import {
  Grid,
  CircularProgress,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const Movements = () => {
  const dates = dateFormats();

  const { selectedCoupon } = useSelector((state) => state.coupons);
  const { textColor } = useSelector((state) => state.local);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { game, gameId, raffleId, num } = useParams();

  const [loading, setLoading] = useState(false);
  const [selectCouponLocal, setSelectCouponLocal] = useState({});
  const [movements, setMovements] = useState([]);

  //Pagianción
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pageCustom, setPageCustom] = useState(1);

  useEffect(() => {
    setLoading(true);
    setSelectCouponLocal(selectedCoupon);
    couponsService
      .getMovements(page, pageSize, gameId, raffleId)
      .then((res) => {
        setMovements(res.content);
        setTotalPages(res.totalPages);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [selectedCoupon, page, pageSize]);

  const cellStyles = {
    fontFamily: "Roboto, sans-serif",
    fontSize: ".9rem",
    fontWeight: "400",
    borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
    cursor: "pointer",
  };

  return (
    <Grid container className={s.container}>
      <Grid item container xs={11} className={s.header} sx={{ mt: { xs: 2 } }}>
        <Grid item container xs={11} className={s.titleContainer}>
          {selectCouponLocal ? (
            <>
              <Grid item xs={1}>
                <ArrowBackIcon
                  sx={{ color: "primary.main", fontSize: "1.8rem" }}
                  onClick={() => {
                    navigate(-1);
                    dispatch(setSelectedCoupon({}));
                  }}
                  className={s.arrow}
                />
              </Grid>
              <Grid item xs={11}>
                <h4>{`${t("couponMovements")}`}</h4>
              </Grid>
            </>
          ) : (
            <></>
          )}
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            mt: 2,
          }}
          className={s.init}
        >
          <p style={{ margin: 0, fontSize: "1.2rem", fontWeight: 400 }}>
            {t("game")}:
          </p>
          <p
            style={{
              margin: 0,
              fontSize: "1.2rem",
              fontWeight: 300,
              marginLeft: "0.5rem",
            }}
          >
            {game}
          </p>
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            mt: 1,
          }}
          className={s.init}
        >
          <p style={{ margin: 0, fontSize: "1.2rem", fontWeight: 400 }}>
            {t("product")}:
          </p>
          <p
            style={{
              margin: 0,
              fontSize: "1.2rem",
              fontWeight: 300,
              marginLeft: "0.5rem",
            }}
          >
            {num}
          </p>
        </Grid>
      </Grid>
      {loading ? (
        <Grid item xs={12} className={s.loader}>
          <CircularProgress size={"4rem"} />
        </Grid>
      ) : movements?.length ? (
        <Grid item container xs={11} className={s.data}>
          <TableContainer className={s.tableContainer}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      backgroundColor: "primary.main",
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("fromCupouns")}
                  </TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "primary.main",
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("toCoupons")}
                  </TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "primary.main",
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("quantity")}
                  </TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "primary.main",
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("price")}
                  </TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "primary.main",
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("source")}
                  </TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "primary.main",
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("destination")}
                  </TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "primary.main",
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("inputDeliveryNote")}
                  </TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "primary.main",
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("outputDeliveryNote")}
                  </TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "primary.main",
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("date")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {movements?.map((m, i) => {
                  return (
                    <React.Fragment key={i}>
                      <TableRow
                        sx={{
                          "&:hover": {
                            backgroundColor: "secondary.light",
                            cursor: "pointer",
                          },
                        }}
                      >
                        <TableCell
                          sx={{
                            ...cellStyles,
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                        >
                          {m?.nroCouponFrom}
                        </TableCell>
                        <TableCell
                          sx={{
                            ...cellStyles,
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                        >
                          {m?.nroCouponTo}
                        </TableCell>
                        <TableCell
                          sx={{
                            ...cellStyles,
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                        >
                          {m?.nroCouponTo - m?.nroCouponFrom + 1}
                        </TableCell>
                        <TableCell
                          sx={{
                            ...cellStyles,
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                        >
                          <Currency value={m?.raffle?.price} />
                        </TableCell>
                        <TableCell
                          sx={{
                            ...cellStyles,
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                        >
                          {m?.source}
                        </TableCell>
                        <TableCell
                          sx={{
                            ...cellStyles,
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                        >
                          {m?.destination || "-"}
                        </TableCell>
                        <TableCell
                          sx={{
                            ...cellStyles,
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                        >
                          {m?.deliveryNoteInput?.nroInput || "-"}
                        </TableCell>
                        <TableCell
                          sx={{
                            ...cellStyles,
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                        >
                          {m?.deliveryNoteOutput?.nroOutput || "-"}
                        </TableCell>
                        <TableCell
                          sx={{
                            ...cellStyles,
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                        >
                          {dates.formatDate(m?.createDate)}
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      ) : (
        <Grid item xs={12} className={s.loader}>
          {t("withoutMovemnts")}
        </Grid>
      )}
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mb: "50px",
        }}
      >
        <Pager
          pageSize={pageSize}
          setPageSize={setPageSize}
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          pageCustom={pageCustom}
          setPageCustom={setPageCustom}
        />
      </Grid>
    </Grid>
  );
};

export default Movements;
